"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
var Authentication_service_1 = require("../authentication/Authentication.service");
var Http_service_1 = require("../http/Http.service");
var ServiceAddress_service_1 = require("../ServiceAddress.service");
exports.default = (function () {
    var serviceAddressService = index_1.instance.getService(ServiceAddress_service_1.ServiceAddressService);
    var authenticationService = index_1.instance.getService(Authentication_service_1.AuthenticationService);
    var domainResolver = function (appName, serviceName) { return __awaiter(void 0, void 0, void 0, function () {
        var ROOT_URL, serviceAddresses, baseUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ROOT_URL = index_1.instance.helper.getRootURL();
                    if (!serviceName) return [3 /*break*/, 2];
                    return [4 /*yield*/, serviceAddressService.getAllServiceAddresses()];
                case 1:
                    serviceAddresses = _a.sent();
                    baseUrl = void 0;
                    if (serviceAddresses[serviceName]) {
                        baseUrl = serviceAddresses[serviceName];
                    }
                    else if (serviceName === 'library-service' || serviceName === 'location.host') {
                        baseUrl = ROOT_URL;
                    }
                    else {
                        baseUrl = ROOT_URL;
                        console.warn(appName + ": " + serviceName + " was not found in the service address service. Possible values are " + Object.keys(serviceAddresses));
                    }
                    return [2 /*return*/, baseUrl.substring(baseUrl.indexOf('//') + 2)];
                case 2: return [2 /*return*/, 'api.seismic.com'];
            }
        });
    }); };
    var authTokenResolver = function () {
        return authenticationService.authHelper.getAccessToken(false) || '';
    };
    var httpService = index_1.instance.getService(Http_service_1.HttpService);
    var customHeadersResolver = function (context, defaultHeaders, options) {
        var integrationContext = {};
        if (options && options.withIntegratorContext) {
            integrationContext = httpService.getGlobalHeaders(options.profileVersionId);
        }
        return Object.assign({}, defaultHeaders, integrationContext);
    };
    return {
        authTokenResolver: authTokenResolver,
        domainResolver: domainResolver,
        customHeadersResolver: customHeadersResolver,
    };
});
//# sourceMappingURL=resolvers.js.map